import { LoaderActions } from '@store/loaders'
import { call, put } from 'redux-saga/effects'

import { NestClient } from '@/nest'
import { AuthActions } from '../actions'

type OauthResponse = Awaited<ReturnType<typeof NestClient.auth.oauth>>

export function* oauthLogin(accessToken: string) {
  yield put(LoaderActions.set('authentication'))

  try {
    const response: OauthResponse = yield call(NestClient.auth.oauth, {
      accessToken,
    })

    yield put(AuthActions.setToken(response.token))
  } catch (error) {
    console.error(error)

    // on success 'authentication' is unset by fetchAuth (started via setToken),
    // so the saga only cleans up when the oauth request itself fails
    yield put(LoaderActions.unset('authentication'))
  }
}
